import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Form, Button, Row, Col } from '_zari/core'

import ValidationSchema from './validacion'
// import * as FormGroups from './formGroups'

import * as CuentaContableService from 'services/cuentaContable.service'

const EnlacesDefectoModal = ({ infoCuentaClase59, validarCuentasClase6789ConEnlaceCierre }) => {
  const __zariContext = React.useContext(ZariContext)

  const formikRef = React.useRef(null)

  const formInitialValues = React.useMemo(() => {
    return {
      enlaceClase79: '',
      descripcionEnlaceClase79: '',
      enlaceClase80: '',
      descripcionEnlaceClase80: '',
      enlaceClase81_88: '',
      descripcionEnlaceClase81_88: '',
      enlaceClase89: infoCuentaClase59.codigoCuenta,
      descripcionEnlaceClase89: `${infoCuentaClase59.codigoCuenta} - ${infoCuentaClase59.descripcion}`
    }
  }, [infoCuentaClase59])

  const onSubmit = React.useCallback(
    (submitData, { setSubmitting }) => {
      __zariContext.loader.open('Actualizando enlaces')

      CuentaContableService.asignarEnlacesCierreClase697Defecto(submitData)
        .then(() => {
          __zariContext.snack('success', 'Enlaces actualizados.')
          validarCuentasClase6789ConEnlaceCierre()
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
        .finally(() => {
          __zariContext.loader.close()
          setSubmitting(false)
        })
    },
    [__zariContext, validarCuentasClase6789ConEnlaceCierre]
  )

  React.useEffect(() => {
    __zariContext.loader.open('Obteniendo configuracion de cuenta clase 59.')

    CuentaContableService.obtenerCuentaClase79Clase80AsEnlaceCierre()
      .then(({ data }) => {
        if (data && formikRef.current) {
          formikRef.current.setValues({
            ...formikRef.current.values,
            enlaceClase79: data.enlaceCuenta79.codigoCuenta,
            descripcionEnlaceClase79: `${data.enlaceCuenta79.codigoCuenta} - ${data.enlaceCuenta79.descripcion}`,
            enlaceClase80: data.enlaceCuenta80.codigoCuenta,
            descripcionEnlaceClase80: `${data.enlaceCuenta80.codigoCuenta} - ${data.enlaceCuenta80.descripcion}`,
            enlaceClase81_88: data.matchCuenta81_88.codigoCuenta,
            descripcionEnlaceClase81_88: `${data.matchCuenta81_88.codigoCuenta} - ${data.matchCuenta81_88.descripcion}`
          })
        }
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  return (
    <Formik
      innerRef={formikRef}
      onSubmit={onSubmit}
      initialValues={formInitialValues}
      validationSchema={ValidationSchema}
    >
      {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
        <>
          <Form>
            {/* <FormGroups.EnlaceClase79FormGroup
              iError={errors.enlaceClase79}
              iTouched={touched.enlaceClase79}
              setFieldValue={setFieldValue}
              iValue={values.descripcionEnlaceClase79}
            />
            <FormGroups.EnlaceClase80FormGroup
              iError={errors.enlaceClase80}
              iTouched={touched.enlaceClase80}
              setFieldValue={setFieldValue}
              iValue={values.descripcionEnlaceClase80}
            />
            <FormGroups.EnlaceClase89FormGroup
              iError={errors.enlaceClase89}
              iTouched={touched.enlaceClase89}
              setFieldValue={setFieldValue}
              iValue={values.descripcionEnlaceClase89}
            /> */}
            <Row>
              <Col md={12}>
                <Button disabled={isSubmitting} onClick={handleSubmit}>
                  Asignar enlaces por defecto
                </Button>
              </Col>
            </Row>
          </Form>
        </>
      )}
    </Formik>
  )
}

export default React.memo(EnlacesDefectoModal)
